import React from 'react';
import { motion } from 'framer-motion';
import { ClosingEmotionalSlide as ClosingEmotionalSlideType } from '../../types';
import { SlideContainer, SlideTitle, SlideSubtitle } from '../common/SlideComponents';

interface ClosingEmotionalSlideProps {
  content: ClosingEmotionalSlideType;
  speakerNotes?: string;
}

const emotionalGradients = {
  hope: 'from-forest-green/5 to-muted-teal/5',
  trust: 'from-deep-slate/5 to-warm-gray/5',
  empowerment: 'from-muted-teal/5 to-forest-green/5',
  reassurance: 'from-warm-gray/5 to-deep-slate/5'
};

export const ClosingEmotionalSlide: React.FC<ClosingEmotionalSlideProps> = ({
  content,
  speakerNotes
}) => {
  const gradientClass = emotionalGradients[content.emotionalTone] || emotionalGradients.trust;
  
  return (
    <SlideContainer className={`bg-gradient-to-br ${gradientClass}`}>
      <div className="flex flex-col justify-center items-center min-h-full text-center">
        <SlideTitle className="text-balance max-w-6xl">
          {content.mainMessage}
        </SlideTitle>
        
        {content.callToAction && (
          <SlideSubtitle className="mt-8 text-balance max-w-4xl">
            {content.callToAction}
          </SlideSubtitle>
        )}
        
        {/* Subtle decorative element */}
        <motion.div
          className="absolute bottom-32 left-1/2 transform -translate-x-1/2"
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.8 }}
        >
          <div className="w-2 h-2 bg-warm-gray/30 rounded-full"></div>
        </motion.div>
      </div>
      
      {speakerNotes && (
        <div className="absolute bottom-4 left-4 opacity-0 hover:opacity-100 transition-opacity duration-200">
          <div className="bg-white/90 backdrop-blur-sm rounded-lg p-3 text-sm text-warm-gray max-w-xs">
            <strong>Speaker Notes:</strong> {speakerNotes}
          </div>
        </div>
      )}
    </SlideContainer>
  );
};